// Administration: the routes and the sidebar rows of `wealth.platform.administration` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.platform.administration',
    routes: [
        {
            frontend: 'view',
            path: 'administration',
            lazy: () => import('@/pages/view/administration/page'),
        },
        {
            // SEP-346. The map of the welcome pack and the firm library. The
            // path is under Administration, so only an administrator opens it.
            frontend: 'view',
            path: 'administration/welcome-pack',
            lazy: () => import('@/pages/view/administration/welcome-pack/page'),
        },
        {
            frontend: 'view',
            path: 'administration/ingest-plans/:id',
            lazy: () => import('@/pages/view/administration/ingest-plan/page'),
        },
    ],
    nav: [
        // Administration (ADR-0004) — the firm-configuration home (User Management +
        // Operational Tolerances). Revealed only to a granted-`admin` user (the
        // SuperAdmin), filtered in `visibleSectionsFor`; placed just before
        // Settings.
        {
            frontend: 'view',
            key: 'administration',
            label: 'Administration',
            href: '/view/administration',
            icon: 'ShieldCheck',
            group: 'administration',
            order: 810,
        },
    ],
});
